import { render, staticRenderFns } from "./ItemChangeUserIconPhoto.vue?vue&type=template&id=1b78f9e4&scoped=true&lang=pug&"
import script from "./ItemChangeUserIconPhoto.vue?vue&type=script&lang=js&"
export * from "./ItemChangeUserIconPhoto.vue?vue&type=script&lang=js&"
import style0 from "./ItemChangeUserIconPhoto.vue?vue&type=style&index=0&id=1b78f9e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b78f9e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VIcon,VProgressCircular})
